import React from "react";
import { size } from "lodash";
import { assessmentFlow } from "../../components/constants/constants";
import { Row } from "reactstrap";
import MobileSectionBar from "../components/MobileSectionbar";

const MobileSidebar = ({ data, currentPage, answers }) => {
  let standing_page = currentPage;
  if (data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP) {
    standing_page =
      size(data.sections) > 0 ? data.sections[0].section_number : 1;
  }
  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container)
    {
      container.classList.add('vertical_scroll');
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove('vertical_scroll');
    }, 800);
  };
  return (
    <div className="col-12 ps-2 pt-3 speak_scroll">
      <div className="row g-0 ps-1">
        <div className="col-6 text-secondary">
          {data && size(data.sections) > 0 ? data.sections[0].section_name : ""}
        </div>
        <div className="col-6 active_question fw-600 pe-3 text-end">
          All questions ({size(data.section_titles)})
        </div>
      </div>
      <div onScroll={handleScroll} className="col-12 d-flex ps-1 pt-3 pb-2 overflow-auto">
        <Row className="bg-white g-0">
          <div>
            <ul class="order-list-container m-0">
              {data &&
                size(data.sections) > 0 &&
                data.section_titles &&
                data.section_titles.map((section, section_id) => {
                  const isLastIndex =
                    section_id === data.section_titles.length - 1;
                  return (
                    <MobileSectionBar
                      section_id={section_id}
                      section_number={section.section_number}
                      standing_page={standing_page}
                      isLastIndex={isLastIndex}
                    />
                  );
                })}
            </ul>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default MobileSidebar;
